<template>
  <div class="card shadow-sm table-card mb-4">
    <div class="form-card-header flex-wrap">
      <div class="section-number"><i class="fe fe-repeat" style="font-size: 12px;"></i></div>
      <div class="flex-grow-1">
        <h6 class="mb-0 font-weight-bold text-white">Change of facility: who did the work</h6>
        <small style="color: rgba(255,255,255,.75);">Requests filed per staff member, approvals, trend and the facilities involved</small>
      </div>
      <PeriodPicker v-model="period" @change="load" default-preset="12m" />
    </div>
    <div class="card-body">
      <div v-if="loading && !d" class="empty-state"><i class="mdi mdi-loading mdi-spin"></i>Loading…</div>
      <div v-else-if="d && !d.total" class="empty-state">No change-of-facility requests in this period.</div>
      <div v-else-if="d" class="row">
        <div class="col-lg-6">
          <h6 class="font-weight-bold small text-uppercase text-muted">Requests by staff ({{ d.total }} in total)</h6>
          <apexchart type="bar" :height="Math.max(220, d.by_staff.length * 30)" :options="staffOptions" :series="staffSeries" :key="'s' + chartKey" />
        </div>
        <div class="col-lg-6">
          <h6 class="font-weight-bold small text-uppercase text-muted">Requests over time</h6>
          <apexchart type="bar" height="220" :options="trendOptions" :series="trendSeries" :key="'t' + chartKey" />
          <div class="row mt-2">
            <div class="col-6">
              <h6 class="font-weight-bold small text-uppercase text-muted">Most left</h6>
              <div v-for="f in d.top_from" :key="'f' + f.facility_id" class="d-flex justify-content-between small border-bottom py-1"><span>{{ f.name }}</span><b>{{ f.count }}</b></div>
            </div>
            <div class="col-6">
              <h6 class="font-weight-bold small text-uppercase text-muted">Most chosen</h6>
              <div v-for="f in d.top_to" :key="'t' + f.facility_id" class="d-flex justify-content-between small border-bottom py-1"><span>{{ f.name }}</span><b>{{ f.count }}</b></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PeriodPicker from "./PeriodPicker.vue";

/** Change-of-facility analytics (GET analytics/change-of-facility). */
export default {
  name: "CofAnalytics",
  components: { PeriodPicker },
  data() {
    return { period: { from: "", to: "" }, d: null, loading: false, chartKey: 0 };
  },
  computed: {
    staffSeries() {
      return [
        { name: "Approved", data: this.d.by_staff.map((s) => s.approved) },
        { name: "Rejected", data: this.d.by_staff.map((s) => s.rejected) },
        { name: "Pending", data: this.d.by_staff.map((s) => s.count - s.approved - s.rejected) },
      ];
    },
    staffOptions() {
      return {
        chart: { stacked: true, toolbar: { show: false } }, colors: ["#059669", "#dc2626", "#f59e0b"],
        plotOptions: { bar: { horizontal: true, barHeight: "70%", borderRadius: 3 } },
        xaxis: { categories: this.d.by_staff.map((s) => s.name + (s.job_title ? ` (${s.job_title})` : "")) },
        dataLabels: { enabled: true }, legend: { position: "top" }, tooltip: { shared: true, intersect: false },
      };
    },
    trendSeries() {
      return [{ name: "Requested", data: this.d.trend.requested }, { name: "Approved", data: this.d.trend.approved }];
    },
    trendOptions() {
      return {
        chart: { toolbar: { show: false } }, colors: ["#93c5fd", "#059669"], plotOptions: { bar: { columnWidth: "60%", borderRadius: 3 } },
        xaxis: { categories: this.d.trend.categories }, dataLabels: { enabled: true }, legend: { position: "top" },
      };
    },
  },
  mounted() { if (this.period.from) this.load(); },
  methods: {
    load() {
      this.loading = true;
      this.$batchGet("/api/v1/auth/analytics/change-of-facility", { params: { from: this.period.from, to: this.period.to } })
        .then((res) => { this.d = res.data.data; this.chartKey++; })
        .catch(() => {})
        .finally(() => { this.loading = false; });
    },
  },
};
</script>

<style scoped>
@import "../../reports/reports.css";
</style>
